import * as css from './Page404.css';
import Btn from '../../component/button/btn/Btn';
import {useTranslation} from 'react-i18next';
import {useNavigate} from 'react-router-dom';
import {useSelector} from 'react-redux';
import getPathByEventRole from '../../functions/getPathByEventRole';
import {useEffect} from 'react';
import TickchakLoader from '../../component/tickchakLoader/TickchakLoader';
import useLoadingState from '../../hooks/useLoadingState';
import {getDefaultPath} from '../../utils/routerUtils';

function Page404({eidParam,pidParam}) {
    const {t}=useTranslation('global');
    const navigate=useNavigate();
    const event = useSelector(s=>s.event);
    const {defaultPid,defaultEid} = useSelector(state => state.user);
    const isWait = useLoadingState(eidParam, pidParam);

    useEffect(()=>{
        if(eidParam && Number(eidParam)===event.eid && ['SUCCESS','FAILED','UPDATED'].includes(event.getEventXHR)) {
            const defaultEventPath=getPathByEventRole(event);
            navigate(defaultEventPath);
        }
    },[event.eid,eidParam]);

    const content404 = (
        <css.container>
            <css.image/>
            <css.text>
                {t('404Text')}
            </css.text>
            <Btn onClick={()=>navigate('/')}>{t('404Button')}</Btn>
        </css.container>
    );

    if(!eidParam && !pidParam) {
        return content404;
    }
    if(isWait)
        return <TickchakLoader showClass={' show'}/>;

    if([event?.getEventXHR, event?.getEventPermissionsXHR, event?.getAccountXHR].includes('FAILED')){
        navigate(getDefaultPath(defaultPid,defaultEid));
        return <></>;
    }
    return content404;
}

export default Page404;
